<template>
  <div class="game-options">
      <div class="button primary fav" @click="$store.dispatch('slot/favorite', { id: game_id })" :class="{ active : _.indexOf(favorites, game_id) > -1}">
        <svg x="0px" y="0px" viewBox="0 0 329.942 329.942" style="enable-background:new 0 0 329.942 329.942;" xml:space="preserve"> <path id="XMLID_16_" d="M329.208,126.666c-1.765-5.431-6.459-9.389-12.109-10.209l-95.822-13.922l-42.854-86.837  c-2.527-5.12-7.742-8.362-13.451-8.362c-5.71,0-10.925,3.242-13.451,8.362l-42.851,86.836l-95.825,13.922  c-5.65,0.821-10.345,4.779-12.109,10.209c-1.764,5.431-0.293,11.392,3.796,15.377l69.339,67.582L57.496,305.07  c-0.965,5.628,1.348,11.315,5.967,14.671c2.613,1.899,5.708,2.865,8.818,2.865c2.387,0,4.784-0.569,6.979-1.723l85.711-45.059  l85.71,45.059c2.208,1.161,4.626,1.714,7.021,1.723c8.275-0.012,14.979-6.723,14.979-15c0-1.152-0.13-2.275-0.376-3.352  l-16.233-94.629l69.339-67.583C329.501,138.057,330.972,132.096,329.208,126.666z"/> </svg>
        
        <slot v-if="_.indexOf(favorites, game_id) > -1">Favorilerden Kaldır</slot>
        <slot v-else>Favorilere Ekle </slot>
        </div>
      <div class="button primary" @click="$parent.fullscreen = true">
        <svg x="0px" y="0px" width="100px" height="100px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve"> <g> <path d="M22.661,20.5H36c1.104,0,2-0.896,2-2s-0.896-2-2-2H19c-1.104,0-2.5,1.276-2.5,2.381v17c0,1.104,0.896,2,2,2s2-0.896,2-2   V24.876l16.042,15.791c0.391,0.391,1.027,0.586,1.539,0.586s1.086-0.195,1.477-0.586c0.781-0.781,0.812-2.237,0.031-3.019   L22.661,20.5z"/> <path d="M83,16.5H66c-1.104,0-2,0.896-2,2s0.896,2,2,2h12.605L61.647,37.648c-0.781,0.781-0.781,2.142,0,2.923   c0.39,0.391,0.902,0.633,1.414,0.633s0.774-0.171,1.164-0.562l16.274-16.5v11.738c0,1.104,0.896,2,2,2s2-0.896,2-2v-17   C84.5,17.776,84.104,16.5,83,16.5z"/> <path d="M36.542,60.962L20.5,76.754V65.881c0-1.104-0.896-2-2-2s-2,0.896-2,2v17c0,1.104,1.396,1.619,2.5,1.619h17   c1.104,0,2-0.896,2-2s-0.896-2-2-2H22.529L39.62,63.6c0.781-0.781,0.656-1.951-0.125-2.732   C38.715,60.086,37.322,60.181,36.542,60.962z"/> <path d="M82.5,63.881c-1.104,0-2,0.896-2,2v11.606L64.226,60.962c-0.78-0.781-1.923-0.781-2.703,0   c-0.781,0.781-0.719,1.856,0.062,2.638l17.152,16.9H66c-1.104,0-2,0.896-2,2s0.896,2,2,2h17c1.104,0,1.5-0.515,1.5-1.619v-17   C84.5,64.776,83.604,63.881,82.5,63.881z"/> </g> </svg>
        Tam Ekran Oyna</div>
      <div class="button primary" @click="runGame()">
        <svg x="0px" y="0px" viewBox="0 0 383.748 383.748" style="enable-background:new 0 0 383.748 383.748;" xml:space="preserve"> <g> <path d="M62.772,95.042C90.904,54.899,137.496,30,187.343,30c83.743,0,151.874,68.13,151.874,151.874h30   C369.217,81.588,287.629,0,187.343,0c-35.038,0-69.061,9.989-98.391,28.888C70.368,40.862,54.245,56.032,41.221,73.593   L2.081,34.641v113.365h113.91L62.772,95.042z"/> <path d="M381.667,235.742h-113.91l53.219,52.965c-28.132,40.142-74.724,65.042-124.571,65.042   c-83.744,0-151.874-68.13-151.874-151.874h-30c0,100.286,81.588,181.874,181.874,181.874c35.038,0,69.062-9.989,98.391-28.888   c18.584-11.975,34.707-27.145,47.731-44.706l39.139,38.952V235.742z"/> </g> </svg>
        Sayfayı Yenile</div>
      <div class="button primary" @click="closeGame()"> 
        <svg width="24px" height="24px" viewBox="0 0 24 24"><g data-name="Layer 2"><g data-name="close"><rect width="24" height="24" transform="rotate(180 12 12)" opacity="0"/><path d="M13.41 12l4.3-4.29a1 1 0 1 0-1.42-1.42L12 10.59l-4.29-4.3a1 1 0 0 0-1.42 1.42l4.3 4.29-4.3 4.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l4.29-4.3 4.29 4.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42z"/></g></g></svg>
        Oyunu Kapat
      </div>
      <div class="games">
        <div class="title">
           <h3>{{ currentProvider }}</h3>
           <span>En Sevilen Oyunları</span>
        </div>
        <swiper :options="swiperOption" v-if="!isMobile && !$parent.isLoading">
          <swiper-slide  v-for="(item, name) in _.sortBy(games, ['sort'])" :key="name" v-if="(isMobile && _.includes(item.devices, 'mobile')) || (!isMobile && _.includes(item.devices, 'desktop')) && name <= 20" v-show="(currentCategory == 'all' || ((currentProvider == item.provider || currentProvider == 'all'))) && game_id != item.id">
              <div class="game">
                <a href="javascript:;" @click="runGameDifferent({id: item.id, device: isMobile})">
                  <img :src="item.image_full_path.replace('{domain}', current_domain).replace('https://static.egamings.com/games/', cdn_url + 'providers/')"/>
                </a>
              </div>
          </swiper-slide>
        </swiper>
      </div>
  </div>
</template>
<script>
  import { ENV_CURRENT_DOMAIN, ENV_CDN_URL } from '../../plugins/replaces'
  import { mapActions } from 'vuex'
  export default {
    data(){
      return{
        swiperOption: {
          direction:'vertical',
          spaceBetween: 5,
          slidesPerView: 4,
          height:500,
          speed:1000,
          autoplay: {
            delay: 3000,
          },
        },
      }
    },
    methods:{
      runGame(){
        let payload = {
          id: this.game_id, 
          device: this.mobile
        }
        this.closeGame();
        this.$store.dispatch('slot/runGame', payload)
      },
      runGameDifferent(payload){
        if(!this.$auth()){
          this.$emit('loginModal', true);
          return false;
        }else{
          this.$store.dispatch('slot/runGame', payload)
        }
      },
      ...mapActions("slot", ["closeGame"]),
    },
    computed:{
      currentProvider(){
        return this.$store.getters['slot/getCurrentProvider'];
      },
      currentCategory(){
        return this.$store.getters['slot/getCurrentCategory'];
      },
      cdn_url(){
       return this.$store.getters['getCdnUrl']
      },
      current_domain(){
        return ENV_CURRENT_DOMAIN;
      },
      games(){
        let games = _.filter(this.$store.getters['slot/getGames'], ['provider', this.currentProvider])
        return _.orderBy(games, [games => games.title.toLowerCase()], ['asc'])
      },
      favorites(){
        return this.$store.getters['slot/getFavorites'];
      },
      game_id(){
        return this.$route.query.game_id
      },
      mobile(){
        return this.$route.query.mobile
      },
    }
  }
</script>